export const baseUrl = 'https://res.cloudinary.com/stitch-fix/image/upload/';
export const SCREEN_VIEW_MAP = {
  welcome: 'vision_onboarding_v2_intro',
  selfie: 'vision_onboarding_v2_selfie',
  fullBody: 'vision_onboarding_v2_full_body_image',
  consent: 'vision_onboarding_v2_terms_agreement'
} as const;
export const posterImages = {
  WOMENS: 'https://res.cloudinary.com/stitch-fix/image/upload/v1757092894/vision/assets/womens_onboarding.jpg',
  MENS: 'https://res.cloudinary.com/stitch-fix/image/upload/v1757092894/vision/assets/mens_onboarding.jpg'
};